import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { GlobeIcon } from '@yonderland/andes-icons';
import { Box, LinkButton, Popover as AndesPopover } from '@yonderland/andes-react';
import NewLanguagePopover from '../language-popover/NewLanguagePopover';
const LanguageMenuItem = props => {
    const { currentLang, defaultLanguages } = props;
    const { alternateUrl } = useAemConfig();
    if (!defaultLanguages || defaultLanguages.length < 2) {
        return null;
    }
    return (_jsxs(AndesPopover, { slim: true, customWidth: "280px", placement: "bottom-end", animated: true, testId: "language_switcher_popup", children: [_jsx(AndesPopover.Trigger, { children: _jsx(Box, { display: "flex", children: _jsx(LinkButton, { testId: "language_switch", theme: "neutral", variant: "tertiary", size: "sm", iconLeft: { source: GlobeIcon }, children: currentLang.toUpperCase() }) }) }), _jsx(AndesPopover.Body, { children: _jsx(NewLanguagePopover, { currentLang: currentLang, alternateUrl: alternateUrl }) })] }));
};
export default LanguageMenuItem;
